import { observer } from 'mobx-react';
import { Button, Flex, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { BaseModal } from '@web/common-ui';
import { useRaffleWinnersStore } from './RaffleWinnersStore';

export const ConfirmCollectionModal = observer(() => {
  const raffleWinnersStore = useRaffleWinnersStore();
  const { t } = useTranslation('organizer-dashboard');
  const selectedWinner = raffleWinnersStore.selectedWinner;

  return (
    <BaseModal
      opened={selectedWinner !== null}
      onClose={() => raffleWinnersStore.clearSelectedWinner()}
      withCloseButton
      title={t('RaffleWinners.ConfirmModal.Title')}
      description={t('RaffleWinners.ConfirmModal.Description')}
      size="500px"
    >
      {selectedWinner && (
        <Flex direction="column" gap="md">
          <Flex justify="space-between" gap="xs">
            <Text fw={600} size="16px">
              {t('RaffleWinnerTable.Columns.UserSearchID')}
            </Text>
            <Text fw={600} size="21px">
              {selectedWinner.userSearchID}
            </Text>
          </Flex>
          <Flex justify="space-between" gap="xs">
            <Text fw={600} size="16px">
              {t('RaffleWinnerTable.Columns.Prize')}
            </Text>
            <Text size="21px" fw={600}>
              {selectedWinner.prize}
            </Text>
          </Flex>
          <Flex direction="column" gap="10px" mt="md">
            <Button
              onClick={() =>
                raffleWinnersStore.confirmCollection(
                  t('RaffleWinners.ConfirmModal.Success'),
                )
              }
              w="100%"
            >
              {t('RaffleWinners.ConfirmModal.Confirm')}
            </Button>
            <Button
              variant="outline"
              onClick={() => raffleWinnersStore.clearSelectedWinner()}
              w="100%"
            >
              {t('RaffleWinners.ConfirmModal.Cancel')}
            </Button>
          </Flex>
        </Flex>
      )}
    </BaseModal>
  );
});
